export default __webpack_public_path__ + "static/media/lamp-green-full.b741062e.svg";